import { render, staticRenderFns } from "./ExamenAvanza.vue?vue&type=template&id=2da852e8&scoped=true&"
import script from "./ExamenAvanza.vue?vue&type=script&lang=js&"
export * from "./ExamenAvanza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da852e8",
  null
  
)

export default component.exports